module.exports = __webpack_public_path__ + "img/plus-square.5ebda5aa.svg";